"use client"
import { useEffect } from "react"
import { usePromotionBanner } from "./PromotionBannerContext"

type PageBannerOverrideProps = {
  pageSpecificBanner?: any | null
  hideAllSitewide?: boolean
}

export default function PageBannerOverride({
  pageSpecificBanner = null,
  hideAllSitewide = false,
}: PageBannerOverrideProps) {
  const { setPageBannerOverride, clearPageBannerOverride } =
    usePromotionBanner()

  useEffect(() => {
    setPageBannerOverride(pageSpecificBanner, hideAllSitewide)
    return () => {
      clearPageBannerOverride()
    }
  }, [
    pageSpecificBanner,
    hideAllSitewide,
    setPageBannerOverride,
    clearPageBannerOverride,
  ])

  return null
}
